<template>
  <v-card elevation="2" outlined shaped tile>
    <v-container>
      <StudentList />
    </v-container>
  </v-card>
</template>

<script>
import StudentList from '@/components/StudentList.vue'

export default {
  name: 'List',
  components: {
    StudentList,
  },
}
</script>
